import { Stack, Typography } from '@mui/material'

import { color } from '@/v2/design-system/tokens'

export type StatusTone = 'normal' | 'info' | 'success' | 'attention' | 'warning' | 'critical'

const TONE_COLOR: Record<StatusTone, string> = {
  normal: color.muted,
  info: color.info,
  success: color.success,
  attention: color.attention,
  warning: color.warning,
  critical: color.critical,
}

/**
 * Punto + texto para monitoreo/alerta/disponibilidad/estado — mismo patrón
 * ya usado en Topbar/SystemStatusStrip (Fase B/C), formalizado aquí como
 * primitiva reutilizable. Nunca depende SOLO del color: siempre lleva
 * texto (accesibilidad — sección "estados no dependientes únicamente del
 * color").
 */
export function StatusIndicator({ tone = 'normal', label }: { tone?: StatusTone; label: string }) {
  return (
    <Stack direction="row" alignItems="center" spacing={0.75}>
      <Stack sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: TONE_COLOR[tone], flexShrink: 0 }} />
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
    </Stack>
  )
}
